document.addEventListener('DOMContentLoaded', () => {
    // Get all galleries
    const galleries = document.getElementsByClassName('wp-block-fse-blocks-fse-gallery');
    
    Array.from(galleries).forEach(gallery => {
        // Get all thumbnail images in this gallery
        const thumbnails = gallery.querySelectorAll('.fse-gallery-thumb');
        
        // Add class to first thumbnail if it exists
        if (thumbnails.length > 0) {
            thumbnails[0].classList.add('fseg-selected');
            const imgPrev = Array.from(gallery.getElementsByClassName('fse-gallery-imgprev'));
                imgPrev[0].src = thumbnails[0].dataset.largeSize;
        }
        
        //  Add click handlers to switch selected class
        thumbnails.forEach(thumb => {
            thumb.addEventListener('click', () => {
                // Remove selected class from all thumbnails in this gallery
                thumbnails.forEach(t => t.classList.remove('fseg-selected'));
                // Add selected class to clicked thumbnail
                thumb.classList.add('fseg-selected');

                const imgPrev = Array.from(gallery.getElementsByClassName('fse-gallery-imgprev'));
                imgPrev[0].src = thumb.dataset.largeSize;
            });
        });
    });
});